import { requestJson, type ApiEnvelope } from '@shared/api/http';
import type { Article, ArticleDraft, ArticlePagination } from './types';

type ArticleListData = {
  content: Article[];
  pagination: ArticlePagination;
};

export async function fetchArticles(
  baseUrl: string,
  page = 1,
  limit = 10,
): Promise<{ articles: Article[]; pagination: ArticlePagination }> {
  const body = await requestJson<ApiEnvelope<ArticleListData>>(
    `/content/article?page=${page}&limit=${limit}`,
    { baseUrl },
  );
  const data = body.data;
  return {
    articles: data?.content ?? [],
    pagination: data?.pagination ?? { total: 0, page, limit },
  };
}

export async function fetchMapArticles(
  baseUrl: string,
  limit = 50,
): Promise<Article[]> {
  const body = await requestJson<ApiEnvelope<ArticleListData>>(
    `/content/article?page=1&limit=${limit}&map=true`,
    { baseUrl },
  );
  return body.data?.content ?? [];
}

export async function createArticle(
  baseUrl: string,
  draft: ArticleDraft,
): Promise<Article> {
  const body = await requestJson<ApiEnvelope<Article>>('/content/article', {
    method: 'POST',
    baseUrl,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(draft),
  });
  return body.data as Article;
}

export async function setArticleLike(baseUrl: string, articleId: string, liked: boolean): Promise<Article> {
  const body = await requestJson<ApiEnvelope<Article>>(`/content/article/${articleId}/like`, {
    method: liked ? 'POST' : 'DELETE',
    baseUrl,
  });
  return body.data as Article;
}

export async function setArticleFavorite(baseUrl: string, articleId: string, favorited: boolean): Promise<Article> {
  const body = await requestJson<ApiEnvelope<Article>>(`/content/article/${articleId}/favorite`, {
    method: favorited ? 'POST' : 'DELETE',
    baseUrl,
  });
  return body.data as Article;
}
